import myTreatmentStyles from "./myTreatment.module.css";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../services/hooks";
import {
  userAllAppointmentProgramsSelector,
  userSelector,
} from "../../services/selectors/user.selectors";
import { useGetAllOpenTreatmentPlansForUserMutation } from "../../services/api/user.api";
import { getPrintDate } from "../../utils/utils";
import Modal from "../modals/modal/Modal";
import AppoitmentProgramPopup from "../modals/appoitmentProgramPopup/appoitmentProgramPopup";
import { ITreatmentPlan } from "../../services/types/user.types";

function MyTreatment() {
  const user = useAppSelector(userSelector);
  const allTreatmentPlans = useAppSelector(userAllAppointmentProgramsSelector)?.filter(plan => plan.appointmentsProgram.statusId !== 0);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [currentTreatmentPlan, setCurrentTreatmentPlan] = useState<ITreatmentPlan | null>(null)


  const [getAllAppointmentProgram] = useGetAllOpenTreatmentPlansForUserMutation();

  useEffect(() => {
    if (!allTreatmentPlans.length) {
      getAllAppointmentProgram({
        companyId: user.companyId,
        UsersGuid: user.guid,
        usersName: user.fullName
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className={myTreatmentStyles.myTreatment}>
      {(openModal && currentTreatmentPlan) && (
        <Modal onClose={() => setOpenModal(false)}>
          <AppoitmentProgramPopup treatmentPlan={currentTreatmentPlan} onClose={() => setOpenModal(false)} />
        </Modal>
      )}
      {allTreatmentPlans && allTreatmentPlans.length !== 0 ?
        (<ul
          className={myTreatmentStyles.allTreatments}>
          {allTreatmentPlans.map((s, index) => (
            <li key={index}
              className={`${myTreatmentStyles.treatment} hover`}
              onClick={() => {
                setOpenModal(true);
                setCurrentTreatmentPlan(s)
              }}
            >
              <div>
                <p className={myTreatmentStyles.treatmentDate}>{getPrintDate(new Date(s.appointmentsProgram.createDate))}</p>
                <p className={myTreatmentStyles.treatmentComment}>{s.appointmentsProgram.name}</p>
              </div>
            </li>
          ))
          }
        </ul>) :
        <h2 className="text">טרם נקבעו תוכניות טיפול</h2>}
    </section >
  );
}

export default MyTreatment;
